import { faPlus } from '@fortawesome/pro-solid-svg-icons'
import { useState, useEffect } from 'react'
import { useNavigate } from 'react-router-dom'
import { useTranslation } from "react-i18next";
import { useGetSuggestionsQuery, useDeleteSuggestionMutation } from '../../../../../Redux/Api/Suggestion';
import Button from '../../../../Shared/Form/Button'
import Title from '../../../../Shared/Title'
import LoadingPage from '../../../LoadingPage'
import { Hydra } from '../../../../../Utils/Hydra'
import BusyArea from '../../../../Shared/BusyArea'
import { useMediaQuery } from "@mui/material";
import GenericDatagrid from '../../../../Datagrid/GenericDatagrid';
import RowActions, { RowAction } from '../../../../Datagrid/DatagridLayout/Rows/RowActions';
import { faEdit, faTrashAlt } from '@fortawesome/pro-light-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { GridRenderCellParams, GridValueGetterParams, GridRowParams } from '@mui/x-data-grid';
import { SuggestionResponseItem } from '../../../../../Redux/Api/Request/Suggestions';

const SuggestionList = () => {
    const navigate = useNavigate()
    const { t, i18n } = useTranslation()

    const [busy, setBusy] = useState(false);

    const [deleteSuggestion] = useDeleteSuggestionMutation()
    const { data: Suggestion, refetch } = useGetSuggestionsQuery();

    const isSmallScreen = useMediaQuery('(min-width: 600px)');

    useEffect(() => {
        refetch();
    }, []);

    const deleteSuggestionAction = async (id: string) => {
        if (busy) return

        setBusy(true)

        try {
            await deleteSuggestion(id)
        } catch (e) {
            let err = e as Hydra.Error
            console.error(err)
        }

        setBusy(false)
        refetch()
    }

    const columns = [
        {
            field: 'title',
            headerName: t('patrickai:pathTitle'),
            flex: 1,
        },
        {
            field: 'text',
            headerName: t('patrickai:suggestionTitle'),
            flex: 1,
            hide: !isSmallScreen,
            valueGetter: (params: GridValueGetterParams<SuggestionResponseItem>) => {
                const textKey = `text_${i18n.language}`;
                return params.row.text[textKey];
            }
        },
        {
            field: 'actions',
            headerName: '',
            width: 120,
            renderCell: (params: GridRenderCellParams<SuggestionResponseItem>) => {
                const actions: RowAction[] = [
                    {
                        label: t('cards:list:adjust'),
                        icon: <FontAwesomeIcon icon={faEdit} />,
                        onClick: () => navigate(`/${i18n.language}/dashboard/admin/suggestion/edit/` + params.row.id),
                    },
                    {
                        label: t('cards:list:delete'),
                        icon: <FontAwesomeIcon icon={faTrashAlt} />,
                        withModal: {
                            onYes: () => { deleteSuggestionAction(params.row.id); }
                        }
                    },
                ];

                return <RowActions actions={actions} />;
            },
        }
    ];

    if (!Suggestion) return <LoadingPage />

    return (
        <>
            <BusyArea busy={busy}>
                <div className='flex flex-col lg:flex-row justify-between items-start lg:items-center'>
                    <Title text={t('patrickai:suggestion')} textNotBold />
                    <Button action={() => navigate(`/${i18n.language}/dashboard/admin/suggestion/create`)} className='my-6' title={t('patrickai:createSuggestion')} icon={faPlus} iconright />
                </div>
                <GenericDatagrid
                    data={Suggestion}
                    columns={columns}
                    onRowClick={(params: GridRowParams<SuggestionResponseItem>) => navigate(`/${i18n.language}/dashboard/admin/suggestion/edit/` + params.row.id)}
                    className='mb-5 lg:mb-10'
                />
            </BusyArea>
        </>
    )
}

export default SuggestionList
